import React from 'react';

const FeaturesSection = () => {
  return (
    <section className="features-section section py-5" style={{ backgroundColor: "#D3E3FD" }}>
      <div className="container">
        {/* Section Title */}
        <div className="row mb-5 text-center">
          <div className="col-lg-12">
            <div className="section-title">
              <h2 className="display-4 text-dark font-weight-bold">
                Wallabies Warm Care: Leading Supplier of Air-Warming Systems
              </h2>
              <p className="lead text-muted mt-3">
                Wallabies Warm Care is the leading producer and supplier of advanced forced air-warming systems and high-quality forced air-warming blankets. We provide effective and reliable warming solutions for medical and healthcare environments, ensuring patient comfort and safety.
              </p>
            </div>
          </div>
        </div>

        {/* Features List */}
        <div className="row">
          {/* Advanced Forced Air-Warming Systems */}
          <div className="col-lg-4 col-md-6 mb-4">
            <div className="single-feature bg-white shadow-lg rounded p-4 text-center transition-shadow">
              <div className="icon-container mb-4">
                {/* Appropriate icon for air-warming systems */}
                <i className="icofont icofont-thermometer" style={{ fontSize: '40px', color: '#1A76D1' }}></i>
              </div>
              <h3 className="text-dark">Advanced Forced Air-Warming Systems</h3>
              <p className="text-muted">
                Our cutting-edge forced air-warming systems are designed for hospitals, clinics, and healthcare facilities, providing efficient and consistent temperature management to ensure patient warmth during procedures.
              </p>
            </div>
          </div>

          {/* High-Quality Warming Blankets */}
          <div className="col-lg-4 col-md-6 mb-4">
            <div className="single-feature bg-white shadow-lg rounded p-4 text-center transition-shadow">
              <div className="icon-container mb-4">
                {/* Appropriate icon for blankets */}
                <i className="icofont icofont-bed" style={{ fontSize: '40px', color: '#1A76D1' }}></i>
              </div>
              <h3 className="text-dark">High-Quality Warming Blankets</h3>
              <p className="text-muted">
                Our forced air-warming blankets provide maximum comfort and warmth. Made from premium materials, these blankets are safe, reliable, and easy to use, ensuring high levels of care for patients.
              </p>
            </div>
          </div>

          {/* Reliable and Safe Products */}
          <div className="col-lg-4 col-md-6 mb-4">
            <div className="single-feature bg-white shadow-lg rounded p-4 text-center transition-shadow">
              <div className="icon-container mb-4">
                {/* Appropriate icon for safety and reliability */}
                <i className="icofont icofont-stethoscope" style={{ fontSize: '40px', color: '#1A76D1' }}></i>
              </div>
              <h3 className="text-dark">Reliable and Safe Products</h3>
              <p className="text-muted">
                At Wallabies Warm Care, we prioritize safety and reliability. All of our products undergo rigorous testing to meet the highest industry standards, ensuring that patients and healthcare professionals have the best equipment.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
